import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'

// Components
import Home from './components/Home'
import About from './components/About'
import Organizations from './components/Organizations'
import Subscribe from './components/Subscribe'

Vue.use(VueRouter)

const routes = [
  { path: '', component: Home },
  { path: '/about', component: About },
  { path: '/organizations', component: Organizations },
  { path: '/subscribe', component: Subscribe },
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  vuetify,
  router
}).$mount('#app')
